import EbayTypes from "./ebay.types";

/*************************************************/

const INITIAL_STATE = {
  connected: false,
  hasValidAccessToken: false,
  requiredPolicies: true,
  loading: false,
  checked: false,
  error: null,
};

/*************************************************/

const ebayReducer = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case EbayTypes.FETCH_EBAY_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case EbayTypes.FETCH_EBAY_STATUS_SUCCESS: {
      const status = action.payload || {};
      return {
        ...state,
        loading: false,
        checked: true,
        connected: status.connected === true,
        hasValidAccessToken: status.has_valid_access_token === true,
        requiredPolicies:
          status.connected === true && status.has_valid_access_token === true
            ? status.required_policies ?? true
            : true,
        error: null,
      };
    }
    case EbayTypes.FETCH_EBAY_STATUS_FAILURE:
      return {
        ...state,
        loading: false,
        checked: true,
        connected: false,
        requiredPolicies: true,
        error: action.payload,
      };
    default:
      return state;
  }
};

/*************************************************/

export default ebayReducer;

/*************************************************/
